import React from 'react'

type LeftSomethingBehindProps = {
  className?: string
}

const _LeftSomethingBehind = (props: LeftSomethingBehindProps) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 22C4.9 22 0 17.1 0 11C0 4.9 4.9 0 11 0C17.1 0 22 4.9 22 11C22 17.1 17.1 22 11 22ZM11 2C6 2 2 6 2 11C2 16 6 20 11 20C16 20 20 16 20 11C20 6 16 2 11 2Z"
      fill="currentColor"
    />
    <path
      d="M11 12C10.4 12 10 11.6 10 11V7C10 6.4 10.4 6 11 6C11.6 6 12 6.4 12 7V11C12 11.6 11.6 12 11 12Z"
      fill="currentColor"
    />
    <path
      d="M11 16C10.7 16 10.5 15.9 10.3 15.7C10.1 15.5 10 15.3 10 15C10 14.9 10 14.7 10.1 14.6C10.2 14.5 10.2 14.4 10.3 14.3C10.6 14 11 13.9 11.4 14.1C11.5 14.1 11.5 14.1 11.6 14.2C11.6 14.2 11.7 14.3 11.8 14.3C11.9 14.4 12 14.5 12 14.6C12 14.7 12 14.9 12 15C12 15.1 12 15.3 11.9 15.4C11.8 15.5 11.8 15.6 11.7 15.7C11.5 15.9 11.3 16 11 16Z"
      fill="currentColor"
    />
  </svg>
)

export default React.memo(_LeftSomethingBehind)
